import { FC } from 'react';

import { IUploadButton } from './UploadButton.types';
import UploadButtonVariant from './UploadButtonVariant';

const UploadButton: FC<IUploadButton> = props => <UploadButtonVariant {...props} />;

export default UploadButton;
